export default {
  themeDetail: null
}
